module.exports = __webpack_public_path__ + "img/Secure Server-amico (1).23a794e2.png";